var exports = {
  "k": "x2b2fbebb--704ba8--container",
  "O": "x2b2fbebb--704ba8--more",
};

module.exports = exports;
